import React, { useEffect } from "react"
import PropTypes from "prop-types"
import {
  Col,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import "toastr/build/toastr.min.css"
//redux
import { useSelector, useDispatch } from "react-redux"
import {
  addNewSpecialDate,
  updateNewSpecialDate,
  getSpecialDates,
} from "../../store/specialdates/actions"

const SpecialCreate = ({ isOpen, specialDates, onClose, setLoading }) => {
  const dispatch = useDispatch()
  const { isSpecialDateCreated, isSpecialDateUpdated } = useSelector(state => ({
    isSpecialDateCreated: state.SpecialDates.isSpecialDateCreated,
    isSpecialDateUpdated: state.SpecialDates.isSpecialDateUpdated,
  }))
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: specialDates?.title || "",
      date: specialDates?.date || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please enter Title"),
      date: Yup.date().required("Please enter Date"),
    }),
    onSubmit: values => {
      setLoading(true)
      if (specialDates) {
        dispatch(updateNewSpecialDate(specialDates["_id"], values))
        validation.resetForm()
      } else {
        dispatch(addNewSpecialDate(values))
        validation.resetForm()
      }
      validation.resetForm()
      setLoading(false)
    },
  })
  /*
    close modal on data creation
    */
  useEffect(() => {
    if (isSpecialDateCreated || isSpecialDateUpdated) {
      dispatch(getSpecialDates())
      onClose()
    }
  }, [onClose, isSpecialDateCreated, isSpecialDateUpdated])

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={onClose} className={"modal-lg"}>
        <ModalHeader toggle={onClose} tag="h4">
          {specialDates ? "Update Special Dates" : "Add Special Dates"}
        </ModalHeader>
        <ModalBody>
          <React.Fragment>
            <Form
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row form>
                <Col xs={12}>
                  <Row>
                    <Col md={6}>
                      <div className="mb-2">
                        <Label className="form-label">Title*</Label>
                        <Input
                          name="title"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.title || ""}
                        />
                        {validation.touched.title && validation.errors.title ? (
                          <span className="text-danger">
                            {validation.errors.title}
                          </span>
                        ) : null}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-2">
                        <Label className="form-label">Dates*</Label>
                        <input
                          className="form-control"
                          type="date"
                          id="date"
                          name="date"
                          value={validation.values.date || ""}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                        />
                        {validation.touched.date && validation.errors.date ? (
                          <span className="text-danger">
                            {validation.errors.date}
                          </span>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="text-end">
                    <button type="submit" className="btn btn-success save-user">
                      {specialDates
                        ? "Update Special Dates"
                        : "Add Special Dates"}
                    </button>
                  </div>
                </Col>
              </Row>
            </Form>
          </React.Fragment>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

SpecialCreate.propTypes = {
  isOpen: PropTypes.any,
  toggle: PropTypes.any,
  onClose: PropTypes.any,
  specialDates: PropTypes.any,
  setLoading: PropTypes.func,
}

export default SpecialCreate
